module.exports = __webpack_public_path__ + "static/media/nuntium.cf3b09d4.jpg";